import IAbstractWorkItemContext from "models/work-items/abstracts/IAbstractWorkItemContext";
import { createContext, useContext } from "react";

const AbstractWorkItemContext = createContext<IAbstractWorkItemContext>({
    workItem: null,
    options: null,
    template: null,
    getOptionsForStatus: () => [],
    updateWorkItemOverview: () => {}
});

const AbstractWorkItemConsumer = AbstractWorkItemContext.Consumer;
const AbstractWorkItemProvider = AbstractWorkItemContext.Provider;

const useAbstractWorkItemContext = () => useContext(AbstractWorkItemContext);

export default useAbstractWorkItemContext;
export { AbstractWorkItemConsumer, AbstractWorkItemProvider };